// ##### Komarov 2025-07-22
import React from 'react';
// ##### 25-05-21 Komarov
import MediumScreenTopHotelsDiv from './MediumScreenTopHotelsDiv';

// ##### Komarov 2025-07-22
const MediumScreenTopHotels = ({ TopHotelContents, GetHotelDetails }) => {
  return (
    <MediumScreenTopHotelsDiv
      // ##### 23-11-08 Komarov
      // width='29vw'
      width="45vw"
      TopHotelContents={TopHotelContents}
      GetHotelDetails={GetHotelDetails}
    />
  );
}; // ##### 23-10-10 Komarov

export default MediumScreenTopHotels;
